/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgPenTool(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M1.47 1.47a.75.75 0 01.706-.199l14.5 3.5a.75.75 0 01.56.582l1.225 6.126.009-.01a.75.75 0 011.06 0l3 3a.75.75 0 010 1.061l-7 7a.75.75 0 01-1.06 0l-3-3a.75.75 0 010-1.06l.009-.01-6.126-1.225a.75.75 0 01-.582-.559l-3.5-14.5a.75.75 0 01.199-.706zm11.284 15.716l4.432-4.432-1.328-6.637L4.415 3.355 9.66 8.598a2.75 2.75 0 11-1.06 1.06L3.354 4.416 6.117 15.86l6.637 1.327zm-2.65-7.058a1.25 1.25 0 101.792 1.744 1.25 1.25 0 00-1.792-1.744zM13.061 19L15 20.94 20.94 15 19 13.06 13.06 19z'
      />
    </svg>
  );
}

export default SvgPenTool;
